import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = {
    key: 0,
    class: "q-pa-md text-h5 text-red text-weight-bold"
};
const _hoisted_4 = { class: "q-pa-md" };
const _hoisted_5 = { class: "q-mb-lg entry-check-table" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "multiline" };
const _hoisted_9 = { class: "q-mb-lg entry-check-table" };
const _hoisted_10 = { class: "multiline" };
const _hoisted_11 = { class: "email-td" };
const _hoisted_12 = { class: "q-mb-lg entry-check-table" };
const _hoisted_13 = { class: "shako-td" };
const _hoisted_14 = { class: "shako-td" };
const _hoisted_15 = { class: "multiline" };
const _hoisted_16 = { key: 2 };
const _hoisted_17 = { key: 3 };
const _hoisted_18 = { key: 0 };
const _hoisted_19 = { class: "q-gutter-sm" };
const _hoisted_20 = { key: 4 };
const _hoisted_21 = { class: "row items-center q-gutter-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_radio = _resolveComponent("q-radio");
    const _component_q_td = _resolveComponent("q-td");
    const _component_file_preview = _resolveComponent("file-preview");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    ...(_ctx.isMt
                        ? [
                            { itemId: _ctx.PageID.nyukyoshaList },
                            { itemId: _ctx.PageID.nyukyoshaDetail }
                        ]
                        : [
                            { itemId: _ctx.PageID.shomeiList },
                            ...(_ctx.shomei.fromEntry
                                ? [
                                    ...(_ctx.isMultipleKeiyaku
                                        ? [{ itemId: _ctx.PageID.shomeiRoomList }]
                                        : []),
                                    { itemId: _ctx.PageID.shomeiPrecautions },
                                    { itemId: _ctx.PageID.shomeiShinsei }
                                ]
                                : [])
                        ]),
                    { itemId: _ctx.PageID.shomeiShinseiEntryCheck }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                (_ctx.shomei.fromEntry)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "入力に誤りがないか確認してください"))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_4, [
                                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "table-caption" }, "契約情報", -1)),
                                    _createElementVNode("table", _hoisted_5, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[11] || (_cache[11] = _createElementVNode("th", null, "申請日", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.shomei.shinseiYmd ? _ctx.date.formatDate(_ctx.shomei.shinseiYmd, "YYYY/MM/DD") : ""), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _cache[12] || (_cache[12] = _createElementVNode("th", null, "契約者名", -1)),
                                                (_ctx.isMt)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.shomei.userName), 1))
                                                    : (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.personal.keiyakusha), 1))
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _cache[13] || (_cache[13] = _createElementVNode("th", null, "住所", -1)),
                                                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.addressAll), 1)
                                            ])
                                        ])
                                    ]),
                                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "table-caption" }, "ご連絡先（証明書を受け取る方の情報を入力してください）", -1)),
                                    _createElementVNode("table", _hoisted_9, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[14] || (_cache[14] = _createElementVNode("th", null, "送付先氏名", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.shomei.soufuName), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _cache[15] || (_cache[15] = _createElementVNode("th", null, "送付先住所", -1)),
                                                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.shomei.addressAll), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, _toDisplayString(_ctx.personal.userKb === _ctx.userType.hojin ? "連絡先" : "携帯電話"), 1),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.shomei.tel), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _cache[16] || (_cache[16] = _createElementVNode("th", null, "メールアドレス", -1)),
                                                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.shomei.email), 1)
                                            ])
                                        ])
                                    ]),
                                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "table-caption" }, "発行したい証明書を選択してください", -1)),
                                    _createElementVNode("table", _hoisted_12, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[17] || (_cache[17] = _createElementVNode("th", { colspan: 2 }, "証明書選択", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.shomei.selectedShomeiKbn?.contents), 1)
                                            ]),
                                            (_ctx.shomei.isShakoShomei)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("tr", null, [
                                                        _cache[18] || (_cache[18] = _createElementVNode("th", {
                                                            rowspan: 2,
                                                            class: "shako-th"
                                                        }, "車庫情報", -1)),
                                                        _cache[19] || (_cache[19] = _createElementVNode("th", { class: "shako-th shako-th-right" }, "駐車場名 ", -1)),
                                                        _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.shomei.shakoChushamei), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[20] || (_cache[20] = _createElementVNode("th", { class: "shako-th shako-th-right" }, "駐車場No.又は場所", -1)),
                                                        _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.shomei.shakoKukaku), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[21] || (_cache[21] = _createElementVNode("th", { colspan: 2 }, [
                                                            _createTextVNode("使用者はどなたに"),
                                                            _createElementVNode("br"),
                                                            _createTextVNode("なりますか？")
                                                        ], -1)),
                                                        _createElementVNode("td", null, [
                                                            _createVNode(_component_q_radio, {
                                                                modelValue: _ctx.shomei.shinseishaKb,
                                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.shomei.shinseishaKb) = $event)),
                                                                val: 1,
                                                                label: "上記契約者",
                                                                disable: ""
                                                            }, null, 8, ["modelValue"]),
                                                            _createVNode(_component_q_radio, {
                                                                modelValue: _ctx.shomei.shinseishaKb,
                                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.shomei.shinseishaKb) = $event)),
                                                                val: 2,
                                                                label: "契約者以外",
                                                                disable: ""
                                                            }, null, 8, ["modelValue"])
                                                        ])
                                                    ])
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (_ctx.shomei.usedByShiyousha)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createElementVNode("tr", null, [
                                                        _cache[22] || (_cache[22] = _createElementVNode("th", { colspan: 2 }, "使用者名", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.shomei.shinseishaName), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[23] || (_cache[23] = _createElementVNode("th", { colspan: 2 }, "使用者住所", -1)),
                                                        _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.getAddressShiyosha()), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[24] || (_cache[24] = _createElementVNode("th", { colspan: 2 }, "使用者電話番号", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.shomei.shinseishaTel), 1)
                                                    ])
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (_ctx.shomei.isKyojuShomei)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                                    _cache[25] || (_cache[25] = _createElementVNode("th", { colspan: 2 }, [
                                                        _createTextVNode("奨学金の申請に"),
                                                        _createElementVNode("br"),
                                                        _createTextVNode("使用しますか？")
                                                    ], -1)),
                                                    _createElementVNode("td", null, [
                                                        _createVNode(_component_q_radio, {
                                                            modelValue: _ctx.shomei.shogakukinKb,
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.shomei.shogakukinKb) = $event)),
                                                            val: 1,
                                                            label: "使用する",
                                                            disable: ""
                                                        }, null, 8, ["modelValue"]),
                                                        _createVNode(_component_q_radio, {
                                                            modelValue: _ctx.shomei.shogakukinKb,
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.shomei.shogakukinKb) = $event)),
                                                            val: 0,
                                                            label: "使用しない",
                                                            disable: ""
                                                        }, null, 8, ["modelValue"])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_ctx.shomei.isRentShomei)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                                                    _cache[26] || (_cache[26] = _createElementVNode("th", { colspan: 2 }, "証明する期間", -1)),
                                                    (!(_ctx.shomei.rentStartDate == null && _ctx.shomei.rentEndDate == null))
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_ctx.shomei.rentStartDate) + "～" + _toDisplayString(_ctx.shomei.rentEndDate), 1))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("tr", null, [
                                                _cache[27] || (_cache[27] = _createElementVNode("th", { colspan: 2 }, "証明書発行手数料(税込)", -1)),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.shomei.tesuryo), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _cache[28] || (_cache[28] = _createElementVNode("th", { colspan: 2 }, [
                                                    _createTextVNode("発行書式の指定は"),
                                                    _createElementVNode("br"),
                                                    _createTextVNode("ございますか？")
                                                ], -1)),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_19, [
                                                        _createVNode(_component_q_radio, {
                                                            modelValue: _ctx.shomei.shosikiSiteiKb,
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.shomei.shosikiSiteiKb) = $event)),
                                                            val: 0,
                                                            label: "なし",
                                                            disable: ""
                                                        }, null, 8, ["modelValue"]),
                                                        _createVNode(_component_q_radio, {
                                                            modelValue: _ctx.shomei.shosikiSiteiKb,
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.shomei.shosikiSiteiKb) = $event)),
                                                            val: 1,
                                                            label: "あり",
                                                            disable: ""
                                                        }, null, 8, ["modelValue"])
                                                    ])
                                                ])
                                            ]),
                                            (_ctx.shomei.shosikiSiteiKb)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                                                    _cache[29] || (_cache[29] = _createElementVNode("th", { colspan: 2 }, "発行書式指定ファイル", -1)),
                                                    _createVNode(_component_q_td, null, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_21, [
                                                                _createElementVNode("span", {
                                                                    class: "text-blue cursor-pointer underline-link",
                                                                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.openPreview()))
                                                                }, _toDisplayString(_ctx.shomei.file ? _ctx.shomei.file.name : _ctx.result ? _ctx.result.fileList[0].fileName : ''), 1)
                                                            ])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    (_ctx.visibleFileDialog)
                                        ? (_openBlock(), _createBlock(_component_file_preview, {
                                            key: 0,
                                            fileCode: _ctx.FileCode.ShomeiFile,
                                            targetNo: _ctx.shomeiNo,
                                            result: _ctx.result,
                                            index: _ctx.fileId,
                                            fileInfo: _ctx.findFilesInfoCommand,
                                            file: _ctx.shomei.file ?? undefined,
                                            onClose: _cache[7] || (_cache[7] = ($event) => (_ctx.visibleFileDialog = false))
                                        }, null, 8, ["fileCode", "targetNo", "result", "index", "fileInfo", "file"]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _: 1
                        }),
                        (_ctx.isMt)
                            ? (_openBlock(), _createBlock(_component_q_card_actions, {
                                key: 0,
                                class: "q-pb-lg",
                                align: "center"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                        label: "戻る",
                                        class: "btn-route col-5 col-md-3",
                                        color: "grey-8",
                                        icon: "navigate_before",
                                        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.$router.push({ name: 'nyukyosha-detail' })))
                                    })
                                ]),
                                _: 1
                            }))
                            : (_openBlock(), _createBlock(_component_q_card_actions, {
                                key: 1,
                                class: "q-pb-lg",
                                align: "center"
                            }, {
                                default: _withCtx(() => [
                                    (_ctx.shomei.fromEntry)
                                        ? (_openBlock(), _createBlock(_component_q_btn, {
                                            key: 0,
                                            label: "戻る",
                                            class: "btn-route col-5 col-md-3",
                                            color: "grey-8",
                                            icon: "navigate_before",
                                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.$router.push({ name: 'shomei-shinsei' })))
                                        }))
                                        : _createCommentVNode("", true),
                                    (_ctx.shomei.fromEntry)
                                        ? (_openBlock(), _createBlock(_component_q_btn, {
                                            key: 1,
                                            label: "申請",
                                            class: "btn-route col-5 col-md-3",
                                            color: "green-7",
                                            "icon-right": "navigate_next",
                                            onClick: _ctx.apply
                                        }, null, 8, ["onClick"]))
                                        : (_openBlock(), _createBlock(_component_q_btn, {
                                            key: 2,
                                            label: "一覧に戻る",
                                            class: "btn-route col-5 col-md-3",
                                            color: "grey-8",
                                            icon: "navigate_before",
                                            onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.$router.push({ name: 'shomei-list' })))
                                        }))
                                ]),
                                _: 1
                            }))
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
